// Tiny framework-agnostic toast emitter. Non-React code (the TanStack query
// client's global error/success handlers) and components both call `toast.*`;
// the <Toaster> component registers the single listener that renders them. Kept
// out of React so api/query-layer code can raise toasts without a hook.
export type ToastVariant = "error" | "success" | "info";

export interface ToastPayload {
  variant: ToastVariant;
  message: string;
}

type Listener = (t: ToastPayload) => void;

let listener: Listener | null = null;

// setToastListener is called by <Toaster> on mount (and cleared on unmount).
export function setToastListener(fn: Listener | null) {
  listener = fn;
}

function emit(variant: ToastVariant, message: string) {
  const m = (message ?? "").trim();
  if (!m || !listener) return;
  listener({ variant, message: m });
}

export const toast = {
  error: (message: string) => emit("error", message),
  success: (message: string) => emit("success", message),
  info: (message: string) => emit("info", message),
};
